import { ReactElement } from 'react';
import { Drawer } from '@/components';
import { FormProvider } from 'react-hook-form';
import { CreateUser } from './CreateUser';
import { CreateUserActions } from './CreateUserActions';
import { useCreateUserForm } from '../hooks/use-create-user-form';
import { useCreateUserMutation } from '../hooks/user-create-user-mutation';
import { toast } from 'react-toastify';
import { queryClient } from '@/lib/tanstack-query';
import { usersQueryKeys } from '../data/query-keys';

type CreateUserDrawerProps = {
  value: boolean;
  setFalse: () => void;
};

export const CreateUserDrawer = (
  props: CreateUserDrawerProps,
): ReactElement => {
  const form = useCreateUserForm();
  const { value, setFalse } = props;
  const createUserMutation = useCreateUserMutation();

  const handleSubmit = form.handleSubmit((formData) => {
    createUserMutation.mutate(formData, {
      onSuccess: () => {
        toast.success('User created successfully!');
        queryClient.invalidateQueries({ queryKey: usersQueryKeys.getUsers });
        setFalse();
        form.reset();
      },
      onError: (error) => {
        toast.error(
          `Failed to create user: ${error.message || 'Unknown error'}`,
        );
        // Optionally, show an error message to the user
      },
    });
  });

  return (
    <FormProvider {...form}>
      <Drawer
        open={value}
        onClose={setFalse}
        title="Create User"
        content={<CreateUser />}
        actions={<CreateUserActions 
          onClose={setFalse} 
          submit={handleSubmit}
          loading={createUserMutation.isPending}
          valid={form.formState.isValid}
        />}
      />
    </FormProvider>
  );
};
